import React, { useMemo } from "react";

import { SocialPreview } from "rhombus-react";

import { getPlacementByType } from "utils/common";
import { SOCIAL_AD_TYPES } from "utils/constants";
import FacebookMOSocialTabSelector from "../creatives/social/FacebookMOSocialTabSelector";

import "./PreviewVersionBladeContent.css";

export default function PreviewVersionBladeContent(props) {
	let {
		isSocial,
		previewProps,
		iframeUrl,
		width,
		height,
		isTypeFBMO,
		isLegacy,
		keyId,
	} = props;

	let {
		socialValues,
		placement,
		adType,
		partner,
	} = previewProps;

	const reloadedKey = `.%${keyId}`;

	let selectedPAC = useMemo(() => {
		const pacType = socialValues?.placementAssetCustomizationType;
		const isPAC = pacType && (pacType !== "none");
		if(!isPAC) { return; }
		return getPlacementByType(socialValues?.placements, placement, partner);
	}, [socialValues, placement, partner]);

	if(isSocial) {
		let $tabSelector;

		if(isTypeFBMO) {
			$tabSelector = <FacebookMOSocialTabSelector />;

			if(selectedPAC) {
				if(adType === SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO) {
					previewProps = {
						...previewProps,
						socialValues: {
							...previewProps.socialValues,
							image: selectedPAC.image,
						},
						aspectRatio: selectedPAC.type.name.toLowerCase(),
					};
				}

				if(adType === SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO) {
					previewProps = {
						...previewProps,
						socialValues: {
							...previewProps.socialValues,
							video: selectedPAC.video,
						},
						aspectRatio: selectedPAC.type.name.toLowerCase(),
					};
				}
			}
		}

		return (
			<div className={`social-version-container ${isTypeFBMO ? "is-fb" : ""}`}>
				{$tabSelector}
				<SocialPreview key={reloadedKey} {...previewProps} />
			</div>
		);
	}

	let iframeProps = {
		className:"preview-version-iframe",
		src:iframeUrl,
		frameBorder:"no",
		scrolling:"no",
		key: reloadedKey,
	};

	if(isLegacy){
		iframeProps.width = width;
		iframeProps.height = height;
	}


	return (
		<>
			<iframe {...iframeProps} />
			<div className="version-size">{width} x {height}</div>
		</>
	);
}

PreviewVersionBladeContent.displayName = "PreviewVersionBladeContent";
